import {Button, Paper} from '@material-ui/core';
import 'Agent/AgentDocumentation/components/DirectDepositInformation.sass';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import React from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import {downloadFile} from 'Shared/utilities/fetchHelpers';

type DirectDepositInformationProps = {
  selectedAgency: AgencyFilters;
} & RouteComponentProps;

const DirectDepositInformation = (props: DirectDepositInformationProps) => {
  const {selectedAgency, match} = props;
  useBreadcrumbs('Direct Deposit Information', match.url);

  return (
    <div className="direct-deposit">
      <p className="direct-deposit__header">Direct Deposit Information</p>
      <Paper className="direct-deposit__details">
        <strong>Electrify your Bank Account</strong>
        <p>
          Authorize American Heritage Life to deposit your commission check in your bank for you and get your money
          fast. It's a quick, convenient and hassle-free method of turning AHL top of the market commissions into cash
          in the bank that you can use.
        </p>
        <strong>What you get</strong>
        <p>
          Electronic transfer of your commissions from our bank to yours. Automatic crediting of your deposit to your
          account-no after hours or weekend waits, no delays because your are out of town or your secretary is sick. A
          laser print 'stub' that tells you exactly how much was deposited and when. More time for appointments and less
          time rushing to the bank.
        </p>
        <strong>What you dont get</strong>
        <p>
          Delays from paper check and mail transactions. Traffic tie-ups when you drive to the bank. Long lines at the
          deposit drive-thru or teller window. Lost checks or 'desk drawer' delayed deposits. Worried, that perhaps your
          check won't arrive in today's mail. Completing the authorization from is almost as easy as filling out a
          deposit slip. Simply click here to download the form. Then fill in the required information, attach a voided
          check and return to:
        </p>
        <p>
          Workplace Commission Accounting Department
          <br />
          American Heritage Life
          <br />
          1776 American Heritage Life Drive
          <br />
          Jacksonville, FL 32224
        </p>
        <p>
          Fax <br />
          1-866-427-3415
        </p>
        <div className="direct-deposit__download-form-button">
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              downloadFile(
                '/api/v1/commissions/documents/CommissionDirectDepositAuthorizationForm' +
                  addFilterParameters({encryptedIdentifier: selectedAgency.encryptedIdentifier}),
                'CommissionDirectDepositAuthorizationForm.pdf'
              )
            }
          >
            Download Form
          </Button>
        </div>
      </Paper>
    </div>
  );
};

export default DirectDepositInformation;
